/**
 * FreightQuotePanel — Step 8 rich detail.
 *
 * Form-shaped mockup that captures the key fields the freighter needs:
 * origin port, destination, weight, volume, incoterm, target arrival.
 * Returned quote (when present) is rendered as a single summary card.
 */
import React from 'react';
import { Truck, Anchor, Plane, MapPin } from 'lucide-react';

const FreightQuotePanel = ({ order }) => {
  const picked = order.factories?.find((f) => f.id === order.pickedQuoteFactoryId);
  const pickedQuote = order.quotes?.find((q) => q.factoryId === order.pickedQuoteFactoryId);

  // Demo numbers — would be live from a freight API in v2
  const estVolumeM3 = Math.max(2, Math.round((order.quantity || 100) * 0.012));
  const estWeightKg = Math.max(50, Math.round((order.quantity || 100) * 1.6));

  return (
    <div className="manifest-rich-panel manifest-freight">
      <div className="manifest-rich-panel-head">
        <div className="manifest-rich-panel-title">
          <Truck size={16} /> Freight quote
        </div>
      </div>

      <div className="manifest-freight-grid">
        <div className="manifest-freight-field">
          <label>Origin (factory)</label>
          <div><MapPin size={11} /> {picked ? `${picked.name}, ${picked.country}` : '— pick a factory in Step 5 —'}</div>
        </div>
        <div className="manifest-freight-field">
          <label>Destination</label>
          <div><MapPin size={11} /> {order.deliveryRegion}</div>
        </div>
        <div className="manifest-freight-field">
          <label>Incoterm at origin</label>
          <div>{pickedQuote?.incoterm || 'TBD'}</div>
        </div>
        <div className="manifest-freight-field">
          <label>Estimated volume</label>
          <div>{estVolumeM3} m³</div>
        </div>
        <div className="manifest-freight-field">
          <label>Estimated weight</label>
          <div>{estWeightKg.toLocaleString()} kg</div>
        </div>
        <div className="manifest-freight-field">
          <label>Target arrival</label>
          <div>Day 45 from PO</div>
        </div>
      </div>

      <div className="manifest-freight-modes">
        <div className="manifest-freight-mode active">
          <Anchor size={14} /> Ocean (LCL)
          <span className="manifest-freight-mode-cost">$2,840 CAD · 18d transit</span>
        </div>
        <div className="manifest-freight-mode">
          <Plane size={14} /> Air freight
          <span className="manifest-freight-mode-cost">$11,250 CAD · 5d transit</span>
        </div>
      </div>

      <div className="manifest-freight-cta">
        <button className="manifest-btn-primary-sm">Email freighter for quote</button>
        <button className="manifest-btn-ghost">Upload received quote</button>
      </div>
    </div>
  );
};

export default FreightQuotePanel;
